import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            id: 0,
            name: '',
            payments: []
        }
    },
    computed : {
        orderedPayments : function () {
            function compare(a,b) {
                if (a.paidDate < b.paidDate)
                    return 1;
                if (a.paidDate > b.paidDate)
                    return -1;
                return 0;
            }
            return this.payments.sort(compare)
        }
    },
    methods: {
        formatDate: formatDate,
        addPayment: addPayment,
        deletePayment: deletePayment,
        load: load,
        getPaymentClassTd: getPaymentClassTd,
        editPayment: editPayment
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push('/home');
            return;
        }
        this.id = this.$route.query.id;
        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getPayment(this.$route.query.id)
        .then((response) => {
            _self.payments = response.data;
            if (_self.payments.length > 0) {
                _self.name = _self.payments[0].name + ' ' + _self.payments[0].surname;
            }
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addPayment() {
    this.$router.push('/add-payment?id=' + this.id)
}

function deletePayment(id) {
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete uplatu? ",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deletePayment(id)
            .then((response) => {
                _self.load()
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function getPaymentClassTd(payment) {
    if(payment.paidMoney === 0){
        return "background: red;"
    }
}

function editPayment(paymentId) {
    this.$router.push('/edit-payment?id=' + paymentId)
}


// WEBPACK FOOTER //
// ./src/components/Users/Payment/UserPayment.js